export const pages = {
	'linkOutHK': { id: 'linkOutHK', page: 'text', getter: () => import(/* webpackChunkName: 'text' */ 'components/bolt/text/text') }
};
export const sections = [

];
